import './css/main.css';
import './css/base/reset.css'
import './css/utils/variables.css'
import { Route, Routes, useLocation } from 'react-router-dom';
import Welcome from './pages/Welcome';
import Navigation from './pages/Navigation';
import Portfolio from './pages/Portfolio';
import {AnimatePresence} from 'framer-motion'
import About from './pages/About';
import Client from './pages/Client';

const Animated = () => {
  const location = useLocation();
  return (
    <AnimatePresence exitBeforeEnter> {/*transition animation every change pages*/}
        <Routes location={location} key= {location.pathname}>
          <Route path='/' element={<Welcome />} />
          <Route path='portfolio' element={<Portfolio />} />
          <Route path='contact' element={<Client />} />
          <Route path='about' element={<About />} />
        </Routes>
    </AnimatePresence>
  )
}

function App() {
  return (
    <div className="App">
      <Navigation />
      <Animated />
    </div>
  );
}

export default App;
